import {
    ResultObj,
    allFetch,
} from "../Domain";

/** 檔案查詢 (參數)
 * @description 檔案查詢 (參數)
 * @param {string} file_id 檔案流水號
 * @param {string} belong 檔案所屬
 * @param {string} type 檔案類型
 * @param {string} id 所屬流水號
 * @param {string} cre_time_start 建立時間起
 * @param {string} cre_time_end 建立時間迄
 * @param {string} blob 是否blob
 * @param {string} isvalid 是否有效 
 * 
 * */
export interface SearchFileParams {
    file_id: string,
    belong: string,
    type: string,
    id: string,
    cre_time_start: string,
    cre_time_end: string,
    blob: boolean,
    isvalid: string
}

/** @description 檔案查詢 (回傳)*/
export interface SearchFileResItem {
    belong: string;
    cre_time: string;
    file_id: number;
    filename: string;
    id: string;
    isvalid: string;
    path: string;
    type: string;
}
/** @description 檔案查詢*/
export const SearchFile =
    async (obj: SearchFileParams
    ): Promise<ResultObj<SearchFileResItem[]>> =>
        await allFetch('Files/SearchFile', obj);



/** 
 * @description 檔案上傳 (參數) 
 * @param {string} belong 檔案所屬(最外層大資料夾)
 * @param {string} type 檔案類型(id資料夾內存放資料夾)
 * @param {string} id 所屬流水號
 * @param {string} base64string 圖片Base64字串
 *  */
export interface UploadFileParams {
    belong: string;
    id: string;
    type: string;
    base64string: string;
}

/** @description 檔案上傳 */
export const UploadFile = async function (obj: FormData) {
    return await allFetch<FormData>('Files/UploadFile', obj);
}

/** 
 * @description 檔案刪除 (參數) 
 * @param {string} file_id 檔案流水號
 *  */
export interface DeleteFileParams {
    file_id: string;
}

/** @description 檔案刪除 */
export const DeleteFile = async function (obj: DeleteFileParams) {
    return await allFetch('Files/DeleteFile', obj);
}

/** 
 * @description 檔案移動 (參數) 
 * @param {string} belong 檔案所屬
 * @param {string} type 檔案類型
 * @param {string} file_id 檔案流水號
 * @param {string} id 新所屬流水號
 *  */
export interface MoveFileParams {
    belong: string;
    file_id: string;
    id: string;
    type: string;
}

/** @description 檔案移動 */
export const MoveFile = async function (obj: MoveFileParams) {
    return await allFetch('Files/MoveFile', obj);
}

/** 
 * @description 從html轉pdf儲存 (參數) 
 * @param {string} belong 檔案所屬
 * @param {string} type 檔案類型
 * @param {string} id 新所屬流水號
 * @param {string} pdf_html 要轉pdf的html
 * @param {string} header_html html的header
 * @param {string} header_height html的header的高度(inch)
 * @param {string} footer_html html的footer
 *  */
export interface UploadHtmlPDFParams {
    belong: string;
    id: string;
    type: string;
    pdf_html: string;
    header_html: string;
    header_height: string;
    footer_html: string;
}

/** @description 從html轉pdf儲存 */
export const UploadHtmlPDF = async function (obj: UploadHtmlPDFParams) {
    return await allFetch('Files/UploadHtmlPDF', obj);
}

/** 
 * @description 從html轉pdf儲存(不須檔案路徑回傳) (參數) 
 * @param {string} belong 檔案所屬
 * @param {string} type 檔案類型
 * @param {string} id 新所屬流水號
 * @param {string} pdf_html 要轉pdf的html
 * @param {string} header_html html的header
 * @param {string} header_height html的header的高度(inch)
 * @param {string} footer_html html的footer
 *  */
export interface UploadHtmlPDFNoWaitParams {
    belong: string;
    id: string;
    type: string;
    pdf_html: string;
    header_html: string;
    header_height: string;
    footer_html: string;
}

/** @description 從html轉pdf儲存(不須檔案路徑回傳) */
export const UploadHtmlPDFNoWait = async function (obj: UploadHtmlPDFNoWaitParams) {
    return await allFetch('Files/UploadHtmlPDFNoWait', obj);
}